export enum ChartType {
  BURN_DOWN = 'burn_down',
  BURN_UP = 'burn_up',
}

export const CHART_TYPE_LABELS = {
  [ChartType.BURN_DOWN]: 'Work Completion',
  [ChartType.BURN_UP]: 'Goal Attainment',
} as const;
